"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAction = exports.Name = void 0;
exports.dispatch = dispatch;
const Name = exports.Name = 'user-action';
const UserAction = exports.UserAction = Name;

/**
 * See Readme for more information.
 * @typedef Data
 * @prop {string[]} metaHierarchy Description of user's action
 * @prop {number} numberValue Metric
 */

/**
 * Utility for dispatching the user-action event.
 * @param {string[]} metaHierarchy Description of user's action.
 * @param {number} numberValue Optional metric data.
 */
function dispatch(metaHierarchy, numberValue) {
  window.dispatchEvent(new CustomEvent(Name, {
    detail: {
      metaHierarchy,
      ...(numberValue !== undefined && {
        numberValue
      })
    }
  }));
}
